import { styled } from "@mui/material";

export const Root = styled("div")({
  width: "100%",
});
